<template>
    <div class="container-fluid py-4">
        <div class="row">
            <div class="col-12 text-center">
                <div class="card mb-4">
                    <div class="card-header">
                        <h3 class="mt-5">Modifier le Contact</h3>
                        <h5 class="text-secondary font-weight-normal">Vous pouvez modifier les informations du contact ici.</h5>
                    </div>
                    <div class="card-body">

                        <div class="row">
                            <div class="col-12 col-lg-12 mx-auto my-5">
                                <div class="multisteps-form__progress">
                                    <button v-for="(step, index) in steps" :key="index"
                                        :class="{ 'js-active': index <= currentStep }" class="multisteps-form__progress-btn"
                                        type="button" title="User Info" @click="setActiveStep(index)">
                                        <span>{{ step.name }}</span>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="multisteps-form mb-5">
                        <div class="error-container" v-if="hasErrors">
                            <div class="alert alert-danger">
                                <b>Veuillez corriger les erreurs suivantes:</b>
                                <ul v-for="(error, field) in errors" :key="field">{{ error }}
                                    <!-- <li v-for="(error, field) in errors" :key="field">{{ error }}</li> -->
                                </ul>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-12 col-lg-8 m-auto">
                                <form @submit.prevent="updateContact" method="post" novalidate="true"
                                    class="multisteps-form__form" style="height: 462px;">

                                    <div v-for="(panel, index) in steps" :key="index"
                                        class="card multisteps-form__panel p-4 border-radius-xl bg-white"
                                        :class="{ 'js-active': index === currentStep }" data-animation="FadeIn">
                                        <div class="row text-center">
                                            <div class="col-12 mx-auto">
                                                <h5 class="font-weight-normal">{{ panel.name }}</h5>
                                                <p>{{ panel.description }}</p>
                                            </div>
                                        </div>
                                        <div class="multisteps-form__content">

                                            <div v-if="index === 0" class="mb-3">
                                                <div class="row">

                                                    <div class="col-md-6">
                                                        <div class="form-group" :class="{ 'has-error': errors.lastname }">
                                                            <label for="lastname" class="form-control-label">Nom</label>
                                                            <input id="lastname" v-model="lastname" type="text"
                                                                class="form-control" placeholder="* Nom" />
                                                            <span v-if="errors.lastname" class="error-message"> <i class="fa-solid fa-circle-exclamation text-danger ms-auto"></i> {{ errors.lastname }} </span>
                                                        </div>
                                                    </div>

                                                    <div class="col-md-6">

                                                        <div class="form-group" :class="{ 'has-error': errors.firstname }">
                                                            <label for="firstname" class="form-control-label">Prénom</label>
                                                            <input id="firstname" v-model="firstname" type="text"
                                                                class="form-control" placeholder="* Prénom" />
                                                            <span v-if="errors.firstname" class="error-message"> <i class="fa-solid fa-circle-exclamation text-danger ms-auto"></i> {{ errors.firstname }}</span>
                                                        </div>
                                                    </div>

                                                    <div class="col-md-4">
                                                        <div class="form-group">
                                                            <label for="civilite">Civilité</label>
                                                            <select id="civilite" v-model="civilite" name="civilite"
                                                                class="form-select">
                                                                <option disabled selected>Sélectionner une civilité</option>
                                                                <option value="Monsieur">Monsieur</option>
                                                                <option value="Madame">Madame</option>
                                                            </select>
                                                        </div>
                                                    </div>

                                                    <div class="col-md-4">
                                                        <div class="form-group">
                                                            <label for="etat_civil">État civil</label>
                                                            <select id="etat_civil" v-model="etat_civil" name="etat_civil"
                                                                class="form-select">
                                                                <option disabled selected>Sélectionner un état civil
                                                                </option>
                                                                <option value="Célibataire">Célibataire</option>
                                                                <option value="Marié(e)">Marié(e)</option>
                                                                <option value="Divorcé(e)">Divorcé(e)</option>
                                                                <option value="Veuf/Veuve">Veuf/Veuve</option>
                                                            </select>
                                                        </div>
                                                    </div>

                                                    <div class="col-md-4">
                                                        <div class="form-group">
                                                            <label for="birthdate">Date de naissance</label>
                                                            <input id="birthdate" v-model="birthdate" type="date"
                                                                name="birthdate" class="form-control">
                                                        </div>
                                                    </div>

                                                    <div class="col-md-6">
                                                        <div class="form-group">
                                                            <label for="nationalite">Nationalité</label>
                                                            <input id="nationalite" v-model="nationalite" type="text"
                                                                class="form-control" placeholder="Nationalité" />
                                                        </div>
                                                    </div>

                                                    <div class="col-md-6">
                                                        <div class="form-group"
                                                            :class="{ 'has-error': errors.subscription_date }">
                                                            <label for="subscription_date">Date d'inscription</label>
                                                            <input id="subscription_date" v-model="subscription_date"
                                                                type="date" class="form-control" />
                                                            <span v-if="errors.subscription_date" class="error-message">
                                                                <i class="fa-solid fa-circle-exclamation text-danger ms-auto"></i> {{ errors.subscription_date }}
                                                            </span>
                                                        </div>
                                                    </div>

                                                </div>
                                            </div>

                                            <div v-if="index === 1" class="mb-3">
                                                <div class="row">

                                                    <div class="col-md-6">
                                                        <div class="form-group" :class="{ 'has-error': errors.telephone }">
                                                            <input id="telephone" v-model="telephone" type="text"
                                                                name="telephone" class="form-control"
                                                                placeholder="Téléphone portable" />
                                                            <span v-if="errors.telephone" class="error-message"> <i class="fa-solid fa-circle-exclamation text-danger ms-auto"></i> {{ errors.telephone }} </span>
                                                        </div>
                                                    </div>

                                                    <div class="col-md-6">
                                                        <div class="form-group" :class="{ 'has-error': errors.email }">
                                                            <input id="email" v-model="email" type="email" name="email"
                                                                class="form-control" placeholder="Email" />
                                                            <span v-if="errors.email" class="error-message"> <i class="fa-solid fa-circle-exclamation text-danger ms-auto"></i> {{ errors.email }} </span>
                                                        </div>
                                                    </div>

                                                    <div class="row justify-content-md-center">
                                                        <div class="col col-lg-6">
                                                            <div class="form-group"
                                                                :class="{ 'has-error': errors.autre_telephone }">
                                                                <input id="autre_telephone" v-model="autre_telephone"
                                                                    type="text" name="autre_telephone" class="form-control"
                                                                    placeholder="Téléphone (autre)" />
                                                                <span v-if="errors.autre_telephone" class="error-message">
                                                                    <i class="fa-solid fa-circle-exclamation text-danger ms-auto"></i> {{
                                                                            errors.autre_telephone }} </span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div v-if="index === 2" class="mb-3">
                                                <div class="row">

                                                    <div class="md-6">
                                                        <div class="form-group"
                                                            :class="{ 'has-error': errors.adresse_postale }">
                                                            <input id="adresse_postale" v-model="adresse_postale"
                                                                type="text" name="adresse_postale" class="form-control"
                                                                placeholder="Adresse" @input="autocompleteAdresse" />
                                                            <ul v-if="suggestions.length" class="suggestions">
                                                                <li v-for="(suggestion, index) in suggestions" :key="index"
                                                                    @click="selectSuggestion(suggestion)">
                                                                    {{ suggestion.display_name }}
                                                                </li>
                                                            </ul>
                                                            <span v-if="errors.adresse_postale" class="error-message">
                                                                <i class="fa-solid fa-circle-exclamation text-danger ms-auto"></i> {{ errors.adresse_postale }}
                                                            </span>
                                                        </div>
                                                    </div>

                                                    <div class="col-md-6">
                                                        <div class="form-group">
                                                            <input id="ville" v-model="ville" type="text" name="ville"
                                                                class="form-control" placeholder="Ville" />
                                                                <span v-if="errors.ville" class="error-message"> <i class="fa-solid fa-circle-exclamation text-danger ms-auto"></i> {{ errors.ville }} </span>
                                                        </div>
                                                    </div>

                                                    <div class="col-md-6">
                                                        <div class="form-group">
                                                            <input id="code_postal" v-model="code_postal" type="text"
                                                                name="code_postal" class="form-control"
                                                                placeholder="Code postal" />
                                                                <span v-if="errors.code_postal" class="error-message"> <i class="fa-solid fa-circle-exclamation text-danger ms-auto"></i> {{ errors.code_postal }} </span>
                                                        </div>
                                                    </div>

                                                </div>
                                            </div>


                                            <div v-if="index === 3" class="mb-3">
                                                <div class="row">

                                                    <div class="md-6">
                                                        <div class="form-group">
                                                            <input id="metier" v-model="metier" type="text" name="metier"
                                                                class="form-control" placeholder="Métier" />
                                                                <span v-if="errors.metier" class="error-message"> <i class="fa-solid fa-circle-exclamation text-danger ms-auto"></i> {{ errors.metier }} </span>
                                                        </div>
                                                    </div>

                                                    <div class="col-md-6">
                                                        <div class="form-group">
                                                            <input id="langue_parlee" v-model="langue_parlee" type="text"
                                                                name="langue_parlee" class="form-control"
                                                                placeholder="Langue(s) parlée(s)" />
                                                                <span v-if="errors.langue_parlee" class="error-message"> <i class="fa-solid fa-circle-exclamation text-danger ms-auto"></i> {{ errors.langue_parlee }} </span>
                                                        </div>
                                                    </div>

                                                    <div class="col-md-6">
                                                        <div class="form-group">
                                                            <input id="num_personne_foyer" v-model="num_personne_foyer"
                                                                type="number" name="num_personne_foyer" class="form-control"
                                                                placeholder="Nombre de personnes dans le foyer" />
                                                            <!-- <span v-if="errors.num_personne_foyer" class="error-message"> <img src="@/assets/images/error-icon.png" alt="Error Icon" class="error-icon" /> {{ errors.num_personne_foyer }} </span> -->
                                                        </div>
                                                    </div>

                                                    <div class="col-md-6">
                                                        <div class="form-group">
                                                            <input id="invite_par" v-model="invite_par" type="text"
                                                                name="invite_par" class="form-control"
                                                                placeholder="Invité par" />
                                                                <span v-if="errors.invite_par" class="error-message"> <i class="fa-solid fa-circle-exclamation text-danger ms-auto"></i> {{ errors.invite_par }} </span>
                                                        </div>
                                                    </div>

                                                    <div class="col-md-6">
                                                        <div class="form-group"
                                                            :class="{ 'has-error': errors.conseiller_nc }">
                                                            <input id="conseiller_nc" v-model="conseiller_nc" type="text"
                                                                class="form-control" placeholder="Nom du conseiller NC" />
                                                            <span v-if="errors.conseiller_nc" class="error-message"> <i class="fa-solid fa-circle-exclamation text-danger ms-auto"></i> {{ errors.conseiller_nc }} </span>
                                                        </div>
                                                    </div>

                                                </div>
                                            </div>


                                            <div v-if="index === 4" class="mb-3">
                                                <div class="row">

                                                    <div class="col-md-4">
                                                        <div class="form-group">
                                                            <label for="est_candidat_prog31">Va faire le programme de 31
                                                                jours ?</label>
                                                            <select id="est_candidat_prog31" v-model="est_candidat_prog31"
                                                                class="form-select">
                                                                <option value="oui">Oui</option>
                                                                <option value="non">Non</option>
                                                            </select>
                                                            <!-- <span v-if="errors.est_candidat_prog31" class="error-message"> <img src="@/assets/images/error-icon.png" alt="Error Icon" class="error-icon" /> {{ errors.est_candidat_prog31 }} </span> -->
                                                        </div>
                                                    </div>

                                                    <div class="col-md-4">
                                                        <div class="form-group">
                                                            <label for="est_converti_cec">Est né(e) de nouveau à Charisma
                                                                ?</label>
                                                            <select id="est_converti_cec" v-model="est_converti_cec"
                                                                class="form-select">
                                                                <option value="oui">Oui</option>
                                                                <option value="non">Non</option>
                                                            </select>
                                                            <!-- <span v-if="errors.est_converti_cec" class="error-message"> <img src="@/assets/images/error-icon.png" alt="Error Icon" class="error-icon" /> {{ errors.est_converti_cec }} </span> -->
                                                        </div>
                                                    </div>

                                                    <div class="col-md-4">
                                                        <div class="form-group">
                                                            <label for="est_candidat_visite">A besoin d'être visitée
                                                                ?</label>
                                                            <select id="est_candidat_visite" v-model="est_candidat_visite"
                                                                class="form-select">
                                                                <option value="oui">Oui</option>
                                                                <option value="non">Non</option>
                                                            </select>
                                                            <!-- <span v-if="errors.est_candidat_visite" class="error-message"> <img src="@/assets/images/error-icon.png" alt="Error Icon" class="error-icon" /> {{ errors.est_candidat_visite }} </span> -->
                                                        </div>
                                                    </div>

                                                    <div class="md-6">
                                                        <div class="form-group"
                                                            :class="{ 'has-error': errors.observations }">
                                                            <label for="observations">Observations</label>
                                                            <textarea id="observations" v-model="observations"
                                                                class="form-control"
                                                                placeholder="Ajoutez vos observations ici"></textarea>
                                                            <!-- <span v-if="errors.observations" class="error-message"> <img src="@/assets/images/error-icon.png" alt="Error Icon" class="error-icon" /> {{ errors.observations }} </span> -->
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>


                                            <div class="button-row d-flex mt-4">
                                                <button v-if="currentStep > 0"
                                                    class="btn bg-gradient-light mb-0 js-btn-prev" type="button"
                                                    @click="prevStep">Précédent</button>

                                                <button v-if="currentStep < steps.length - 1"
                                                    class="btn bg-gradient-dark ms-auto mb-0 js-btn-next" type="button"
                                                    @click="nextStep">Suivant</button>
                                                <button v-else class="btn bg-gradient-dark ms-auto mb-0 js-btn-submit"
                                                    type="button" @click="updateContact">Enregistrer les
                                                    modifications</button>
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
  
<script>
import axios from 'axios';
import { userService } from '@/_services';

export default {
    data() {
        return {
            // progression actuelle
            currentStep: 0,
            //initialisation
            contactDetails: {},
            civilite: '',
            firstname: '',
            lastname: '',
            etat_civil: '',
            birthdate: '',
            nationalite: '',
            adresse_postale: '',
            genre: '',
            code_postal: '',
            ville: '',
            telephone: '',
            email: '',
            metier: '',
            langue_parlee: '',
            autre_telephone: '',
            num_personne_foyer: '',
            secteur_gf: '',
            source_id: 1,
            invite_par: '',
            subscription_date: '',
            conseiller_nc: '',
            est_candidat_prog31: Boolean,
            est_converti_cec: Boolean,
            est_candidat_visite: Boolean,
            observations: '',
            est_mineur: false,
            is_acive: false,
            suggestions: [],
            errors: {
                lastname: null,
                firstname: null,
                email: null,
                telephone: null,
                autre_telephone: null,
                adresse_postale: null,
                subscription_date: null,
                conseiller_nc: null,
                code_postal: null,
                ville: null,
                langue_parlee: null,
                invite_par: null,
                metier: null,
            },


            steps: [
                { name: 'Informations personnelles', description: 'Fournissez les Informations personnelles du contact' },
                { name: 'Contacts', description: 'Coordonnées du contact' },
                { name: 'Adresse', description: 'Adresse du contact' },
                { name: 'Autres informations', description: '' },
                { name: 'Questions', description: 'Questions et observations' },
            ],
        };
    },
    async created() {
        const contactId = this.$route.params.id;
        try {
            const response = await userService.getUserById(contactId);
            this.civilite = response.data.civilite;
            this.firstname = response.data.firstname;
            this.lastname = response.data.lastname;
            this.etat_civil = response.data.etat_civil;
            this.birthdate = response.data.birthdate;
            this.nationalite = response.data.nationalite;
            this.adresse_postale = response.data.adresse_postale;
            this.genre = response.data.genre;
            this.code_postal = response.data.code_postal;
            this.ville = response.data.ville;
            this.telephone = response.data.telephone;
            this.email = response.data.email;
            this.metier = response.data.metier
            this.langue_parlee = response.data.langue_parlee;
            this.autre_telephone = response.data.autre_telephone;
            this.num_personne_foyer = response.data.num_personne_foyer;
            this.secteur_gf = response.data.secteur_gf;
            this.invite_par = response.data.invite_par;
            this.subscription_date = response.data.subscription_date;
            this.conseiller_nc = response.data.conseiller_nc;
            this.est_candidat_prog31 = response.data.est_candidat_prog31;
            this.est_converti_cec = response.data.est_converti_cec;
            this.est_candidat_visite = response.data.est_candidat_visite;
            this.observations = response.data.observations;
            this.est_mineur = response.data.est_mineur;
            this.is_acive = response.data.is_acive;

        } catch (error) {
            console.error('Erreur lors du chargement des détails du contact :', error);
        }
    },
    computed: {
        hasErrors() {
            return Object.values(this.errors).some(error => error !== null);
        },
        // hasEmptyFields() {
        //     return !this.lastname && !this.firstname && !this.email && !this.telephone && this.adresse_postale;
        // }
    },
    methods: {

        autocompleteAdresse: async function () {
            try {
                const response = await axios.get('https://nominatim.openstreetmap.org/search', {
                    params: {
                        format: 'json',
                        addressdetails: 1,
                        q: this.adresse_postale,
                        countrycodes: 'FR',
                    },
                });
                if (response.data && response.data.length > 0) {
                    this.suggestions = response.data;
                    // console.log(this.suggestions)
                } else {
                    this.suggestions = [];
                }
            } catch (error) {
                console.error("Erreur lors de la recherche d'adresse :", error);
                this.suggestions = [];
            }
        },

        selectSuggestion: function (suggestion) {
            this.adresse_postale = suggestion.display_name;
            this.code_postal = suggestion.address.postcode;
            this.ville = suggestion.address.city;

            this.suggestions = [];
        },

        async updateContact() {

            //Verification si les propriétés de contactDetails sont définies correctement.

            this.contactDetails.civilite = this.civilite === undefined ? '' : this.civilite
            this.contactDetails.firstname = this.firstname === undefined ? '' : this.firstname
            this.contactDetails.lastname = this.lastname === undefined ? '' : this.lastname
            this.contactDetails.etat_civil = this.etat_civil === undefined ? '' : this.etat_civil
            this.contactDetails.birthdate = this.birthdate === undefined ? '' : this.birthdate
            this.contactDetails.nationalite = this.nationalite === undefined ? '' : this.nationalite
            this.contactDetails.adresse_postale = this.adresse_postale === undefined ? '' : this.adresse_postale
            this.contactDetails.code_postal = this.code_postal === undefined ? '' : this.code_postal
            this.contactDetails.ville = this.ville === undefined ? '' : this.ville
            this.contactDetails.telephone = this.telephone === undefined ? '' : this.telephone
            this.contactDetails.email = this.email === undefined ? '' : this.email
            this.contactDetails.metier = this.metier === undefined ? '' : this.metier
            this.contactDetails.langue_parlee = this.langue_parlee === undefined ? '' : this.langue_parlee
            this.contactDetails.autre_telephone = this.autre_telephone === undefined ? '' : this.autre_telephone
            this.contactDetails.num_personne_foyer = this.num_personne_foyer === undefined ? '' : this.num_personne_foyer
            this.contactDetails.invite_par = this.invite_par === undefined ? '' : this.invite_par
            this.contactDetails.subscription_date = this.subscription_date === undefined ? '' : this.subscription_date
            this.contactDetails.conseiller_nc = this.conseiller_nc === undefined ? '' : this.conseiller_nc
            this.contactDetails.est_candidat_prog31 = (this.est_candidat_prog31 === 'oui') ? true : false
            this.contactDetails.est_converti_cec = (this.est_converti_cec === 'oui') ? true : false

            this.contactDetails.est_candidat_visite = (this.est_candidat_visite === 'oui') ? true : false
            this.contactDetails.observations = this.observations === undefined ? '' : this.observations


            // this.contactDetails.civilite = this.civilite

            // propriétés et valeurs à mettre à jour pour le contact
            const fieldsToUpdate = {
                civilite: this.civilite,
                firstname: this.firstname,
                lastname: this.lastname,
                etat_civil: this.etat_civil,
                birthdate: this.birthdate,
                nationalite: this.nationalite,
                adresse_postale: this.adresse_postale,
                code_postal: this.code_postal,
                ville: this.ville,
                telephone: this.telephone,
                email: this.email,
                metier: this.metier,
                langue_parlee: this.langue_parlee,
                autre_telephone: this.autre_telephone,
                num_personne_foyer: this.num_personne_foyer,
                invite_par: this.invite_par,

                subscription_date: this.subscription_date,

                conseiller_nc: this.conseiller_nc,
                est_candidat_prog31: this.est_candidat_prog31,
                est_converti_cec: this.est_converti_cec,
                est_candidat_visite: this.est_candidat_visite,
                observations: this.observations,
                source_id: 1,
            };

            this.errors = {
                lastname: null,
                firstname: null,
                email: null,
                telephone: null,
                autre_telephone: null,
                adresse_postale: null,
                subscription_date: null,
                conseiller_nc: null,
                code_postal: null,
                ville: null,
                langue_parlee: null,
                invite_par: null,
                metier: null,

            };

            if (!this.contactDetails.lastname.trim()) {
                this.errors.lastname = "Le champ du nom est vide!";
            } else if (!this.validName(this.contactDetails.lastname)) {
                this.errors.lastname = "Le nom doit commencer par une majuscule suivi de minuscules!"
            }

            if (!this.contactDetails.firstname.trim()) {
                this.errors.firstname = "Le champ du prenom est vide!";
            } else if (!this.validName(this.contactDetails.firstname)) {
                this.errors.firstname = "Le prenom doit commencer par une majuscule suivi de minuscules!"
            }

            if (this.contactDetails.telephone && !this.validTelephone(this.contactDetails.telephone)) {
                this.errors.telephone = "Le téléphone doit commencer par 0 et avoir 10 chiffres!";
            }

            if (this.contactDetails.autre_telephone && !this.validTelephone(this.contactDetails.autre_telephone)) {
                this.errors.autre_telephone = "Le téléphone (autre) doit commencer par 0 et avoir 10 chiffres!";
            }

            if (this.contactDetails.email && !this.validEmail(this.contactDetails.email)) {
                this.errors.email = "Un email valide est requis!";
            }

            // if (!this.contactDetails.adresse_postale) {
            //     this.errors.adresse_postale = "Le champ adresse est vide!";
            // }

            if (!this.contactDetails.subscription_date.trim()) {
                this.errors.subscription_date = "Veuillez sélectionner une date d'inscription!";
            }

            if (this.contactDetails.code_postal && !this.validCode_Postal(this.contactDetails.code_postal)) {
                this.errors.code_postal = "Le code postal doit contenir 5 chiffres!";
            }

            if (this.contactDetails.ville && !this.validVille(this.contactDetails.ville)) {
                this.errors.ville = "Le nom de la ville doit commencer par une majuscule et être composé uniquement de lettres!";
            }

            if (this.contactDetails.langue_parlee && !this.validLangue_Parlee(this.contactDetails.langue_parlee)) {
                this.errors.langue_parlee = "Les langues doivent commencer par une majuscule et peuvent être séparées par des virgules!";
            }

            if (this.contactDetails.invite_par && !this.validName(this.contactDetails.invite_par)) {
                this.errors.invite_par = "Le format du champ 'Invité par' est incorrect. Il doit commencer par une majuscule, suivi de lettres minuscules, d'accents, d'espaces!";
            }

            if (this.contactDetails.conseiller_nc && !this.validName(this.contactDetails.conseiller_nc)) {
                this.errors.conseiller_nc = "Le format du champ 'Conseiller NC' est incorrect. Il doit commencer par une majuscule, suivi de lettres minuscules, d'accents, d'espaces!";
            }

            if (this.contactDetails.metier && !this.validName(this.contactDetails.metier)) {
                this.errors.metier = "Le format du champ 'Metier' est incorrect. Il doit commencer par une majuscule, suivi de lettres minuscules, d'accents, d'espaces!";
            }


            console.log('contactDetails :', fieldsToUpdate);
            if (Object.values(this.errors).every(error => error === null)) {
                console.log(this.contactDetails);
                const contactId = this.$route.params.id;
                try {
                    await userService.updateContactById(contactId, fieldsToUpdate);
                    console.log('Contact mis à jour avec succès!');
                    // this.$router.push(`/details/${this.contactDetails.id}`);
                    this.$router.push('/contactlist');
                } catch (error) {
                    console.error('Erreur lors de la mise à jour du contact :', error);
                }
            }
        },
        validName: function (lastname) {
            var re = /^[A-Z][a-zÀ-ÖØ-öø-ÿ\s]+$/;
            return re.test(lastname)
        },
        validTelephone: function (telephone) {
            var re = /^[0]\d{9}$/;
            return re.test(telephone)
        },
        validEmail: function (email) {
            var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return re.test(email);
        },
        validCode_Postal: function (code_postal) {
            var re = /^\d{5}$/;
            return re.test(code_postal)
        },
        validVille: function (ville) {
            var re = /^[A-Za-zÀ-ÖØ-öø-ÿ- ']+$/;
            return re.test(ville)
        },
        validLangue_Parlee: function (langue_parlee) {
            var re = /^([A-Z][a-zÀ-ÖØ-öø-ÿ\s]+,?)+$/;
            return re.test(langue_parlee)
        },

        nextStep() {
            if (this.currentStep < this.steps.length - 1) {
                this.currentStep++;
            }
        },
        prevStep() {
            if (this.currentStep > 0) {
                this.currentStep--;
            }
        },
        setActiveStep(index) {
            this.currentStep = index;
        },
    },
};
</script>

<style>
input:focus::placeholder,
input:not(:placeholder-shown)::placeholder {
    color: #6c757d;
    font-size: 12px;
    transition: all 0.2s ease-in-out;
}

.error-container {
    margin-top: 1rem;
    max-width: 700px;
    margin-left: auto;
    margin-right: auto;
}

.alert {
    padding: 10px;
    margin-bottom: 10px;
    border: 1px solid #000000;
    border-radius: 4px;
    color: #000000;
    line-height: 1;
    text-align: center;
}

.alert b {
    color: #000000;
    line-height: 3;
    text-align: center;
}
.error-message {
    color: #d9534f;
    font-size: 14px;
    margin-top: 4px;
    display: block;
    text-align: left;
}
.error-icon {
    margin-right: 5px;
    max-width: 22px;
    max-height: 22px;
}

.suggestions li {
    padding: 8px;
    cursor: pointer;
}

.suggestions li:hover {
    background-color: #f0f0f0;
}
.multisteps-form__panel {
    transition: opacity 0.3s ease-in-out;
}

.js-active {
    opacity: 1 !important;
}
</style>
  